import {ChatScopEnum} from '../../activity-logs/activity-form/activity-form.component';

export function manupilateInternalChat(chat) {
    if (chat.scope === ChatScopEnum.Public) {
        return chat;
    }
    let message = chat?.message;
    for (let i = 0; i < chat?.tags?.length; i++) {
        message = chat.message.replaceAll(
            '@{' + chat.tags[i]?.user.id + '}',
            chat.tags[i]?.user.name
        );
    }
    return {...chat, message: message};
}
